<template>
    <div class="bg-neutral-white">
        <CCol sm="12" xs="6" class="text-right">
            <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                <span style="margin-top:20px">Requested</span>
            </h5>
    
        </CCol>
        <div style="clear:both"></div>
        <CCol sm="12">
            <CRow class="text-center">
                <hooper settings="hooperSettings" ref="hooper" :itemsToShow="3" pagination="yes" style="height: 50px;">
                    <slide>
    
                        <CButton type="button" class="button-border-blue text-white" style="width:100px">
                            Requested
                        </CButton>
                    </slide>
                    <slide>
                        <label class="mt-2 text-black">
                                                Applied
                                            </label>
                    </slide>
                    <slide>
                        <label class="mt-2 text-black">
                                                Available
                                                </label>
                    </slide>
    
    
                </hooper>
    
    
            </CRow>
            <br />
            <h1 class="custom-14px">Today</h1>
            <CCard class="border-requested m-2">
    
                <CCol sm="12">
                    <CRow>
                        <div style="width:20%">
                            <div class="p-2">
                                <img style="width:40px" src="../assets/img/card1.png" />
                            </div>
                        </div>
                        <div style="width:80%">
                            <CRow class="p-2 mt-2">
                                <div style="width:50%">
                                    <CButton class="badge-blue">Home Cleaning</CButton>
                                </div>
                                <div style="width:50%"><label class="custom-date-muted">17 Jan 2024 at 10:05 AM</label></div>
                                <h1 class="custom-14px-700 ml-2 mt-2">
                                    Atiqah Putri
                                </h1>
                                <div style="width:80%">
                                    <h3 class="custom-12px ml-2">A requester offer a cleaning home job for you on saturday (10:00 AM) </h3>
                                </div>
                                <div style="width:20%"><img src="../assets/img/arrowright.png" /></div>
                            </CRow>
                        </div>
                    </CRow>
                </CCol>
            </CCard>
    
            <CCard class="border-requested m-2">
    
                <CCol sm="12">
                    <CRow>
                        <div style="width:20%">
                            <div class="p-2">
                                <img style="width:40px" src="../assets/img/card2.png" />
                            </div>
                        </div>
                        <div style="width:80%">
                            <CRow class="p-2 mt-2">
                                <div style="width:50%">
                                    <CButton class="badge-blue">Home Cleaning</CButton>
                                </div>
                                <div style="width:50%"><label class="custom-date-muted">17 Jan 2024 at 10:05 AM</label></div>
                                <h1 class="custom-14px-700 ml-2 mt-2">
                                    Atiqah Putri
                                </h1>
                                <div style="width:80%">
                                    <h3 class="custom-12px ml-2">A requester offer a cleaning home job for you on saturday (10:00 AM) </h3>
                                </div>
                                <div style="width:20%"><img src="../assets/img/arrowright.png" /></div>
                            </CRow>
                        </div>
                    </CRow>
                </CCol>
            </CCard>
    
            <CCard class="border-requested m-2">
    
                <CCol sm="12">
                    <CRow>
                        <div style="width:20%">
                            <div class="p-2">
                                <img style="width:40px" src="../assets/img/card3.png" />
                            </div>
                        </div>
                        <div style="width:80%">
                            <CRow class="p-2 mt-2">
                                <div style="width:50%">
                                    <CButton class="badge-blue">Home Cleaning</CButton>
                                </div>
                                <div style="width:50%"><label class="custom-date-muted">17 Jan 2024 at 10:05 AM</label></div>
                                <h1 class="custom-14px-700 ml-2 mt-2">
                                    Atiqah Putri
                                </h1>
                                <div style="width:80%">
                                    <h3 class="custom-12px ml-2">A requester offer a cleaning home job for you on saturday (10:00 AM) </h3>
                                </div>
                                <div style="width:20%"><img src="../assets/img/arrowright.png" /></div>
                            </CRow>
                        </div>
                    </CRow>
                </CCol>
            </CCard>

            <div v-if="isLanguagePopupVisible" class="popup-all backdrop-all" @click="closePopup">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100%" src="../assets/img/sendnoti.png" />
                    <h3 class="custom-18px-500 text-center">Waiting genie helper to approve your wishes</h3>
                    <CButton type="button" class="button-border-blue text-white mt-4" block @click="GoToBooking()">Continue</CButton>
                </div>
            </div>
        </div>
            <br />   <br />   <br />
        </CCol>
        <MainlayoutBottom></MainlayoutBottom>
    </div>
</template>


<script>
import MainlayoutBottom from "../containers/TheBottomCustom.vue";

import backgroundUrl from "../assets/img/bgHomeUser.png";
import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination,
} from "hooper";

import "hooper/dist/hooper.css";
export default ({
    components: {
        Hooper,
        Slide,
        HooperNavigation,
        HooperPagination,
        MainlayoutBottom,
    },
    data() {
        return {
            isLanguagePopupVisible: true,
            code: ["", "", "", ""],
            hooperSettings1: {
                hideArrows: true,
            },
            backgroundUrl

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },
        GoToBooking()
        {
            this.$router.push("ProfileUser");
        }



    }
})
</script>

<style scoped>
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>